module.exports = __webpack_public_path__ + "img/tilt_1.beaf41d7.jpg";